import React, { useState } from "react";
import ReactLoading from "react-loading";
import { GLOBAL_STYLES, STATUS } from "../../../../appConstants";
import { reduceLongName } from "../../../../ReusableFunctions/reusableFunctions";
import Paid from "../../../../assets/paid.svg";
import InProgress from "../../../../assets/inprogress.svg";
import Received from "../../../../assets/recieved.svg";
import accepted from "../../../../assets/accepted.svg";
import cancle from "../../../../assets/cancle.svg";
import outForService from "../../../../assets/outForService.svg";
import reschedule from "../../../../assets/reschedule.svg";
import Completed from "../../../../assets/completed.svg";
import OnHold from "../../../../assets/OnHold.svg";
import Tippy from "@tippyjs/react";
import useWindowSize from "../../../../hooks/useWindowSize";

const AdminStatusCountCard = ({
  backGround,
  loading,
  title,
  data,
  icon,
  isDisabled,
  iconStyle,
  callback,
  isActive,
}) => {
  const [imgIcon, setImgIcon] = useState(icon);
  const { currentWidth } = useWindowSize();
  const pickIcon = (status) => {
    switch (status) {
      case STATUS.ACCEPTED:
        return accepted;

      case STATUS.OUT_FOR_SERVICE:
        return outForService;

      case STATUS.COMPLETED:
        return Completed;

      case STATUS.INPROGRESS:
        return InProgress;

      case STATUS.RESCHEDULED:
        return reschedule;

      case STATUS.PAID:
        return Paid;

      case STATUS.PLACED:
        return OnHold;

      case STATUS.CANCELLED:
        return cancle;

      case STATUS.HOLD:
        return OnHold;

      case "Total Orders":
        return Received;
    }
  };
  return (
    <>
      {loading ? (
        <div style={{ position: "relative", height: "100%", width: "100%" }}>
          <ReactLoading
            className="loading"
            type={"spin"}
            color={GLOBAL_STYLES.BG_ACTIVE}
            height={"13%"}
            width={"10%"}
          />
        </div>
      ) : (
        <div
        className={`w-[265px] bg-[#FFFFFF] rounded-[12px] py-3 px-3 flex flex-col shadow-[0px_0px_8.8px_0px_#2A406E26] 
          box-border `}
          onMouseOver={() => setImgIcon(icon)}
          onMouseOut={() => setImgIcon(icon)}
          style={{
            boxSizing: "border-box",
            transition: 'border 0.2s ease, outline 0.2s ease',  
            boxShadow: "0px 0px 8.8px 4px #2A406E26",
            border:!isActive ? "none" : "2px solid #0F5EFF",
            cursor: isDisabled ? "not-allowed" : "pointer",
            pointerEvents: isDisabled || !callback ? "none" : undefined,
            color: backGround ? "white" : undefined,
          }}
        >
          <div
            onClick={() => {
              callback(data?.order_status);
            }}
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
              <div className="flex gap-3">
                <div className="">
                  <img src={pickIcon(data?.order_status)} alt="" width={currentWidth<1366?35:45} height={currentWidth<1366?35:45} />
                </div>
                <div className="flex flex-col">
                  <span className="font-manrope font-[700] custom-md:text-[20px] text-[16px] text-[#1E1E1E]">
                  {data?.total_orders}
                  </span>
                  <span className="font-manrope font-[500] text-[#3B3B3B] custom-md:text-[15px] text-[14px] -mt-[2px]">
                    {data?.order_status}
                  </span>
                </div>
              </div>
              <div className="w-full h-1 border-dotted border-b border-b-[#D9D9D9] mt-1 mb-1"></div>
                <Tippy content={data?.total_amount}>
              <div className="mt-[5px] ml-2 font-manrope font-[500] text-[#3B3B3B] custom-md:text-[18px] text-[14px]">
              ₹{data?.total_amount}
              </div>
                </Tippy>
            </div>
          </div>
      )}
    </>
  );
};

export default AdminStatusCountCard;